export const official = {
  methods: {
    //TODO: 根据id获取公文内容
    async getOfficeId(id) {
      let res = await this.$http.get(`/tenant/official/document/${id}`);
      return res;
    },
    //TODO：获取全部公文
    async getOffice(params) {
      let { pageNum, pageSize, title } = params;
      let res = await this.$http.get("/tenant/official/document/list", {
        title: title ?? null,
        pageNum,
        pageSize,
      });

      return res;
    },
    //TODO: 新增公文
    async addOffice(data) {
      let res = await this.$http.post("/tenant/official/document", data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO:修改公文
    async upOffice(data) {
      let res = await this.$http.put("/tenant/official/document", data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO:删除公文
    async delOffice(id) {
      let res = await this.$http.delete(`/tenant/official/document/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 发送公文
    async sendOffices(id) {
        let res = await this.$http.post(`/tenant/official/document/send/${id}`);
        if (res.code == 200) {
          this.$message({ message: res.msg, type: "success" });
        } else {
          this.$message.error(res.msg);
        }
        return res;
      },
    //上传文件
    async uploadOffFile(file) {
      let res = await this.$http.post("/file/upload1", file, {
        "Content-Type": "multipart/form-data",
      });
      return res;
    },
    //查询已读未读人员
    async queryOffIsRead(params) {
      let res = await this.$http.get("/tenant/official/document/isRead", params);
      return res;
    },
  },
};
